import { render } from "./GainersLosers.vue?vue&type=template&id=7ab4a968&ts=true"
import script from "./GainersLosers.vue?vue&type=script&lang=ts"
export * from "./GainersLosers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__